<div class="footer-wrapper pb-4">
  <!-- CTA Banner: Only for guest users -->
  <div
    *ngIf="!userLoggedIn"
    class="cta-banner position-relative d-flex align-items-center justify-content-center text-center text-white mb-5"
    style="background-image: url('assets/images/home/Footer.png')"
  >
    <div class="cta-content py-5 px-3 d-flex flex-column align-items-center justify-content-center">
      <h2 class="cta-title hf text-uppercase mb-2 f120">JOIN US!</h2>
      <h3 class="cta-subtitle hf text-uppercase mb-4 f80">GET STARTED NOW.</h3>

      <!-- Rotating Circular Stamp Link -->
      <a routerLink="/auth/signup" (click)="taptotop()" class="circular-stamp-link d-inline-block">
        <div class="circular-stamp">
          <svg viewBox="0 0 100 100" class="stamp-svg">
            <path id="footerCirclePath" d="M 50, 50 m -35, 0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0" fill="none" />
            <text class="stamp-text">
              <textPath href="#footerCirclePath" startOffset="0%">CREATE YOUR ACCOUNT • CREATE YOUR ACCOUNT • CREATE YOUR ACCOUNT •</textPath>
            </text>
          </svg>
          <div class="stamp-center">
            <svg viewBox="0 0 24 24" class="stamp-arrow" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square">
              <line x1="7" y1="17" x2="17" y2="7"></line>
              <polyline points="7 7 17 7 17 17"></polyline>
            </svg>
          </div>
        </div>
      </a>
    </div>
  </div>

  <!-- Footer Links Box / Card -->
  <div class="container-fluid">
    <div class="footer-card bg-dark-card p-4 p-md-5 rounded-4">
      <div class="row g-4 justify-content-between align-items-start pb-5">
        <!-- Column 1: Logo and Contacts -->
        <div class="col-12 col-md-3 col-lg-4 text-center text-lg-start mb-lg-0">
          <div class="footer-logo d-inline-block">
            <img src="assets/images/home/footerlogo.png" alt="XDGE Logo" class="logo-img" />
          </div>
        </div>

        <!-- Column 2: First Menu -->
        <div class="col-6 col-md-3 col-lg-2">
          <ul class="footer-links-list list-unstyled mb-0">
            <li><a (click)="taptotop()" routerLink="/home">Home</a></li>
            <li><a (click)="taptotop()" routerLink="/about-us">About Us</a></li>
            <li><a (click)="taptotop()" routerLink="/faqs">FAQs</a></li>
            <li><a (click)="taptotop()" routerLink="/scoring-system">Scoring System</a></li>
          </ul>
        </div>

        <!-- Column 3: Second Menu -->
        <div class="col-6 col-md-3 col-lg-2">
          <ul class="footer-links-list list-unstyled mb-0">
            <li><a [routerLink]="userInfo?.id ? '/sports' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'sports')">Sports</a></li>
            <li>
              <a [routerLink]="userInfo?.id ? '/events/eventByOthers' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'event')">Events</a>
            </li>
            <li>
              <a [routerLink]="userInfo?.id ? '/store' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'XDGE Store')">Xdge Store</a>
            </li>
            <li><a [routerLink]="userInfo?.id ? '/media' : null" (click)="userInfo?.id ? '' : onExploreClick($event, 'media')">Media</a></li>
          </ul>
        </div>

        <!-- Column 4: Contact & Socials -->
        <div class="col-12 col-md-3 col-lg-4 text-center text-md-start">
          <ul class="contact-info-list list-unstyled mb-4">
            <li class="mb-2">
              <a href="tel:8339343934" class="text-decoration-none contact-link"> (833) 934 3934 / 833 XDGEXDG </a>
            </li>
            <li class="mb-3">
              <a href="mailto:xdgesports@gmail.com" class="text-decoration-none contact-link"> xdgesports&#64;gmail.com </a>
            </li>
          </ul>

          <!-- Social Icons -->
          <div class="social-icons-row d-flex gap-3 justify-content-center justify-content-md-start align-items-center">
            <a
              href="https://www.facebook.com/profile.php?id=61574730988349"
              target="_blank"
              class="social-btn d-flex align-items-center justify-content-center"
            >
              <span [innerHTML]="ICONS.facebook | safeHtml"></span>
            </a>
            <a href="https://www.instagram.com/xdgesports/" target="_blank" class="social-btn d-flex align-items-center justify-content-center">
              <span [innerHTML]="ICONS.instagram | safeHtml"></span>
            </a>
          </div>
        </div>
      </div>

      <!-- Red Separator Line -->
      <hr class="footer-hr my-4" />

      <!-- Bottom Bar -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        <div class="copyright fs-7">© XDGE 2014-{{ date | date: 'yyyy' }}. All rights reserved.</div>
        <div class="bottom-links d-flex gap-4 fs-7">
          <a (click)="taptotop()" routerLink="/privacy-policy" class="bottom-link text-decoration-none">Privacy Policy</a>
          <a (click)="taptotop()" routerLink="/terms-conditions" class="bottom-link text-decoration-none">Terms of Use</a>
        </div>
      </div>
    </div>
  </div>
</div>
